import React, { useState, useEffect } from "react";
import moment from "moment";
import lightenDarkenColor from "../../utils/lightenDarkenColor";
import { useGetSuggestedUserQuery } from "../../redux/features/users/userApi";
import UserModal from "../user/UserModal";
import { ThreeCircles } from "react-loader-spinner";

function SingleTeam({ team, notify }) {
  const {
    id,
    teamName,
    teamDescription,
    teamColor,
    teamCreatror,
    teamMembers,
    timeStamp,
  } = team || {};
  const [open, setOpen] = useState(false);
  const [check, setCheck] = React.useState(false);

  const { data, isLoading, isError, error } = useGetSuggestedUserQuery(
    {},
    {
      skip: !check,
    }
  );

  useEffect(() => {
    if (isError) {
      notify(error.error, "error");
      setCheck(false);
    }
  }, [isError]);

  const handleModal = () => {
    setOpen(!open);
    setCheck(true);
  };

  return (
    <>
      <div
        className="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
        draggable="true"
      >
        <button
          className="absolute top-0 right-0  items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
          onClick={handleModal}
        >
          <svg
            className="w-4 h-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
          </svg>
        </button>
        <div className="absolute  top-0 right-0 mt-3 mr-2">
          {" "}
          <ThreeCircles
            height="25"
            width="25"
            color="#4C51BF"
            wrapperStyle={{}}
            wrapperclassName=""
            visible={isLoading}
            ariaLabel="three-circles-rotating"
            outerCircleColor=""
            innerCircleColor=""
            middleCircleColor=""
          />
        </div>

        <span
          style={{
            background: teamColor,
            color: lightenDarkenColor(teamColor, -80),
          }}
          className="flex items-center h-6 px-3 text-xs font-semibold rounded-full"
        >
          {teamName}
        </span>
        <h4 className="mt-3 text-sm font-medium">{teamDescription}</h4>
        <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
          <div className="flex items-end ">
            <svg
              className="w-4 h-4 text-gray-300 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clipRule="evenodd"
              />
            </svg>

            <span className="ml-1 leading-none">
              {moment(timeStamp).format("ll")}
            </span>
          </div>
        </div>
        <div className="flex items-center w-full mt-1 text-xs font-medium text-gray-400">
          <div className="flex items-end ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 text-gray-300 fill-current mr-[2px] -ml-[2px]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z" />
            </svg>

            <span className="ml-1 leading-none">{teamCreatror?.name}</span>
          </div>
        </div>

        {data && data.length > 0 ? (
          <UserModal
            open={open}
            handleModal={handleModal}
            id={id}
            data={data}
            teamMembers={teamMembers}
            setCheck={setCheck}
            teamName={teamName}
            teamCreatror={teamCreatror}
          />
        ) : null}
      </div>
    </>
  );
}

export default SingleTeam;
